import React, { memo } from "react";
import "./icons.css";

const LocationSVG = memo(({color = 'var(--inyc-secondary)',
  className,
  width = '24px',
  height = '24px',
  outline = false,
}) => {
  return (
    <svg
      className={`svg-icon ${className || ""}`}
      fill={outline ? "none" : color}
      stroke={outline ? color : "none"}
      strokeWidth={outline ? 1.75 : 0}
      strokeLinejoin={outline ? "round" : undefined}
      strokeLinecap={outline ? "round" : undefined}
      color={color}
      height={height}
      width={width}
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
      xmlnsXlink="http://www.w3.org/1999/xlink"
      x="0px"
      y="0px"
      viewBox="0 0 24 24"
      enableBackground="new 0 0 24 24"
      xmlSpace="preserve"
    >
      {outline ? (
        <g>
          <path d="M12,1c-4.97,0-9,4.03-9,9c0,6.75,9,13,9,13s9-6.25,9-13C21,5.03,16.97,1,12,1z" />
          <circle cx="12" cy="10" r="3" />
        </g>
      ) : (
        <g id="Location-Pin-Filled">
          <path d="M12,1c-4.97,0-9,4.03-9,9c0,6.75,9,13,9,13s9-6.25,9-13C21,5.03,16.97,1,12,1z M12,13c-1.66,0-3-1.34-3-3s1.34-3,3-3 s3,1.34,3,3S13.66,13,12,13z"></path>
        </g>
      )}
    </svg>
  );
});

LocationSVG.displayName = 'LocationSVG';

export default LocationSVG;
